const resources = {
    getTheseBeforeGone: 'Procurez-vous-les avant qu’ils ne partent',
    items: 'Articles',
    item: 'Article'

};

export default function getResource(label) {
    return resources[label];
}
